export const namespace = 'guidLink/';

export const GuidLinkGetters = {
  GET_ESTIMATE_LINK: namespace + 'getEstimateLink',
  GET_SERVICE_ORDER: namespace + 'getServiceOrder',
  GET_PARTS_ORDER: namespace + 'getPartsOrder',
  GET_ESTIMATE_LINK_LOOKUPS: namespace + 'getEstimateLookups',
  GET_ESTIMATE_LINK_STATUS_MAP: namespace + 'getEstimateLinkStatusMap',
  GET_UNIT: namespace + 'getUnit',
  GET_PAYMENT_LINK: namespace + 'getPaymentLink'
};

export const GuidLinkActions = {
  FETCH_ESTIMATE_LINK: namespace + 'fetchEstimateLink',
  FETCH_SERVICE_ORDER: namespace + 'fetchServiceOrder',
  FETCH_PARTS_ORDER: namespace + 'fetchPartsOrder',
  FETCH_ESTIMATE_LINK_LOOKUPS: namespace + 'fetchEstimateLinkLookups',
  FETCH_UNIT: namespace + 'fetchUnit',
  SUBMIT_ESTIMATE_LINK: namespace + 'submitEstimateLink',
  GET_PAYMENT_LINK: namespace + 'getPaymentLink'
};

export const GuidLinkMutations = {
  SET_ESTIMATE_LINK: namespace + 'setEstimateLink',
  SET_ESTIMATE_LINK_LOOKUPS: namespace + 'setEstimateLookups',
  SET_OPERATION_STATUS: namespace + 'setOperationStatus',
  SET_ESTIMATE_LINK_PROP: namespace + 'setEstimateLinkProp',
  SET_UNIT: namespace + 'setUnit',
  SET_PAYMENT_LINK: namespace + 'setPaymentLink'
};
